<div class="mt-6">
  <app-page-header
    [pageTitle]="'Establecimientos'"
    [className]="'mb-3!'"
    [showCreateButton]="permissionAuth.canCreate('clientes')"
    [textButton]="'Nuevo'"
    (onCreateClick)="create()"
  />

  <!-- Alta en línea con grilla: reemplazada por el modal del establecimiento (2026-10-05)
  @if (nuevos) {
    <div class="mb-4 space-y-3">
      <app-establecimientos-grilla [filas]="nuevos" [mostrarErrores]="mostrarErroresNuevos" [deshabilitada]="guardandoNuevos" />
      <div class="flex justify-end gap-2">
        <app-button variant="outline" [disabled]="guardandoNuevos" (btnClick)="cancelarNuevos()">Cancelar</app-button>
        <app-button [disabled]="guardandoNuevos" (btnClick)="guardarNuevos()">Guardar</app-button>
      </div>
    </div>
  }
  -->

  <!-- Filtros: sacados de la ficha del cliente, un cliente tiene pocos establecimientos.
  <app-filters-container
    [hasData]="establecimientos.length > 0"
    [hasActiveFilters]="hasActiveFilters"
    [loading]="loading"
    (clearFilters)="clearFilters()"
  >
    <app-search-input
      label="Buscar"
      placeholder="Buscar por nombre..."
      [value]="searchTerm"
      (searchChange)="onSearchChange($event)"
    />

    <app-filter-select
      label="Objetivo"
      [value]="selectedObjetivo"
      [options]="objetivosOptions"
      (valueChange)="onObjetivoChange($event)"
    />
  </app-filters-container>
  -->

  <!-- Tabla -->
  <app-data-table
    [columns]="columns"
    [data]="establecimientos"
    [loading]="loading"
    [emptyTitle]="'No hay establecimientos registrados'"
    [emptySubtitle]="''"
    (rowClick)="onRowClick($event)"
  >
    <!-- Nombre -->
    <ng-template appTableCell="nombre" let-establecimiento>
      {{ establecimiento.nombre }}
    </ng-template>

    <!-- Zona -->
    <ng-template appTableCell="direccion" let-establecimiento>
      {{ establecimiento.direccion?.zona?.nombre || '-' }}
    </ng-template>

    <!-- Animales -->
    <ng-template appTableCell="animales" let-establecimiento>
      {{ establecimiento.animales_count ?? '-' }}
    </ng-template>

    <!-- Próximo agendamiento -->
    <ng-template appTableCell="proximo" let-establecimiento>
      @if (establecimiento.proximo_agendamiento; as proximo) {
        {{ proximo.tipo }} {{ proximo.fecha | date:'dd/MM' }}
      } @else {
        <span class="text-gray-400 dark:text-gray-500">-</span>
      }
    </ng-template>

    <!-- Kilómetro -->
    <ng-template appTableCell="km" let-establecimiento>
      @if (establecimiento.km !== null) {
        {{ establecimiento.km | number:'1.0-0' }}
      } @else {
        <span class="text-gray-400 dark:text-gray-500">-</span>
      }
    </ng-template>

    <!-- Acciones -->
    <ng-template appTableCell="acciones" let-establecimiento let-index="index">
      <app-delete-trigger *hasPermission="'clientes.registros:delete'"
        [title]="'Eliminar establecimiento'"
        [disabled]="deleting && (deletingIndex === index)"
        (clickDeleteEvent)="delete(establecimiento.id, index); $event.stopPropagation()"
      />
    </ng-template>
  </app-data-table>

  <!-- Paginación: solo si un cliente pasa los 100 establecimientos -->
  @if (lastPage > 1) {
    <app-pagination
      [currentPage]="currentPage"
      [lastPage]="lastPage"
      [perPage]="perPage"
      [total]="total"
      (pageChange)="onPageChange($event)"
      (perPageChange)="onPerPageChange($event)"
    />
  }
</div>
